export default {
  title: '产品属性',
  addFirstLevel: '新增属性组',
  addSecondLevel: '新增属性',
  attributeName: '属性名称',
  addModal: '新增属性组',
  addSecondModal: '新增属性',
  editModal: '编辑属性',
  required: '请输入属性名称',
};
